var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#8288A2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M16.14 3c.518 0 .938.42.938.938v.937h.172c2.068 0 3.75 1.682 3.75 3.75v7.625c0 2.068-1.682 3.75-3.75 3.75H6.75C4.682 20 3 18.318 3 16.25V8.625c0-2.068 1.682-3.75 3.75-3.75h.172v-.938c0-.517.42-.937.937-.937h.047c.518 0 .938.42.938.938v.937h6.312v-.938c0-.517.42-.937.938-.937h.047zm2.984 10H4.875v2.969l-.001.015.001.266c0 .985.763 1.794 1.729 1.87l.146.005h10.5c1.034 0 1.875-.841 1.875-1.875v-.281L19.124 13zM6.922 6.75H6.75c-1.034 0-1.875.841-1.875 1.875V11h14.249l.001-2.375c0-.985-.763-1.794-1.729-1.87l-.146-.005h-.172v.938c0 .517-.42.937-.937.937l-.024-.002-.023.002c-.481 0-.877-.362-.931-.828l-.007-.11V6.75H8.844v.938c0 .517-.42.937-.938.937l-.024-.002-.023.002c-.48 0-.877-.362-.93-.828l-.007-.11V6.75z",
    transform: "translate(-314.000000, -256.000000) translate(146.000000, 248.000000) translate(168.000000, 8.000000)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarGrey);
export default __webpack_public_path__ + "static/media/calendar-grey.dbf4f3875d6209eb8a89f9709e07645c.svg";
export { ForwardRef as ReactComponent };